import { useQuery } from '@apollo/client'
import { ErrorComponent, ProgressSpinner } from '@medical/components'
import { STAFF_CREATE_SCHEDULE_AVAILABLE_SHIFTS } from '@medical/constant/permissions'
import { checkStaffPermission, onPageChange } from '@medical/libs'
import RecruitmentScheduleShiftListScene from '@medical/pages/staff/RecruitmentScheduleShift/RecruitmentScheduleShiftList/RecruitmentScheduleShiftListScene'
import { useCustom } from '@medical/provider/context'
import queryString from 'query-string'
import React, { useEffect, useState } from 'react'

import { SCHEDULE_AVAILABLESHIFT_GROUPS_CONNECTION } from './RecruitmentScheduleShiftList.graphql'

const RecruitmentScheduleShiftList = ({ history, location: { search } }) => {
  const fullUrl = window.location.href
  const [{ i18n }] = useCustom()
  const {
    page = 1,
    rowsPerPage = 10,
    fullname,
    name_contains,
  } = queryString.parse(search)
  const [orderBy, setOrderBy] = useState('startDate_DESC')
  const first = parseInt(rowsPerPage, 10)
  const skip = (parseInt(page, 10) - 1) * parseInt(rowsPerPage, 10)
  const variables = {
    first: first < 0 ? 10 : first,
    skip: skip < 0 ? 0 : skip,
    availableShiftsWhere2: {
      isEditedIndividually: true,
      workSchedule: null,
      deletedAt: null,
    },
    availableShiftsFirst2: 1,
    availableShiftsSkip2: 0,
    orderBy,
    where: {
      isRecruitmentShift: true,
      deletedAt: null,
      name_contains,
      AvailableShift_some: {
        deletedAt: null,
        workSchedule: null,
        Staff_AvailableShift_updatedByToStaff: fullname
          ? {
              OR: [
                {
                  firstname_contains: fullname,
                },
                {
                  lastname_contains: fullname,
                },
                {
                  firstnameKana_contains: fullname,
                },
                {
                  lastnameKana_contains: fullname,
                },
              ],
            }
          : undefined,
      },
    },
  }
  const { loading, error, data, refetch } = useQuery(
    SCHEDULE_AVAILABLESHIFT_GROUPS_CONNECTION,
    {
      variables,
      fetchPolicy: 'network-only',
    }
  )

  useEffect(() => {
    if (fullUrl && !fullUrl.includes('create') && !fullUrl.includes('detail')) {
      refetch()
    }
  }, [fullUrl])
  const onSortHandle = e => {
    if (e.sortField === 'startDate') {
      setOrderBy(
        orderBy !== 'startDate_ASC' ? 'startDate_ASC' : 'startDate_DESC'
      )
    }
    if (e.sortField === 'createdAt') {
      setOrderBy(
        orderBy !== 'createdAt_ASC' ? 'createdAt_ASC' : 'createdAt_DESC'
      )
    }
    if (e.sortField === 'updatedAt') {
      setOrderBy(
        orderBy !== 'updatedAt_ASC' ? 'updatedAt_ASC' : 'updatedAt_DESC'
      )
    }
  }
  // useEffect(() => {
  //   setIsUpdateRecruitmentShift(!isUpdateRecruitmentShift)
  // }, [isUpdateRecruitmentShift])
  const isCreateScheduleAvailableShift = checkStaffPermission({
    functionName: STAFF_CREATE_SCHEDULE_AVAILABLE_SHIFTS,
  })
  if (loading) return <ProgressSpinner />
  if (error) return <ErrorComponent error={error} />

  const {
    scheduledAvailableShiftGroupsConnection: {
      edges,
      aggregate: { count },
    },
  } = data
  const renderAvailableDayInMoth = monthly => {
    const monthlys = JSON.parse(monthly)
    if (Array.isArray(monthlys)) {
      const res = []
      for (let i = 0; i < monthlys.length; i++) {
        const inWeekDetail = renderAvailableDayInWeekly(i + 1, monthlys[i])
        if (inWeekDetail) {
          res.push(inWeekDetail)
        }
      }
      return res.join('、')
    }
  }
  const renderAvailableDayInWeekly = (text, week) => {
    const inWeek = renderAvailableDay(
      week[0],
      week[1],
      week[2],
      week[3],
      week[4],
      week[5],
      week[6],
      false
    )
    if (!inWeek || inWeek === '') {
      return null
    }
    return `第${text} (${inWeek})`
  }
  const renderAvailableDay = (
    isAvailableOnMonday,
    isAvailableOnTuesday,
    isAvailableOnWednesday,
    isAvailableOnThursday,
    isAvailableOnFriday,
    isAvailableOnSaturday,
    isAvailableOnSunday,
    isAvailableOnHoliday
  ) => {
    let availableDay = ''
    if (
      !isAvailableOnMonday ||
      !isAvailableOnTuesday ||
      !isAvailableOnWednesday ||
      !isAvailableOnThursday ||
      !isAvailableOnFriday
    ) {
      if (isAvailableOnMonday) availableDay += '月'
      if (isAvailableOnTuesday) availableDay += '火'
      if (isAvailableOnWednesday) availableDay += '水'
      if (isAvailableOnThursday) availableDay += '木'
      if (isAvailableOnFriday) availableDay += '金'
      if (isAvailableOnSaturday) availableDay += '土'
      if (isAvailableOnSunday) availableDay += '日'
      if (isAvailableOnHoliday) availableDay += '祝'
    } else {
      availableDay = '平日'
      if (isAvailableOnSaturday) availableDay += '土'
      if (isAvailableOnSunday) availableDay += '日'
      if (isAvailableOnHoliday) availableDay += '祝'
    }
    return availableDay
  }
  const fortmatDate = node => {
    const typeTime = node.repeatSetting
    if (typeTime === 'DAILY') {
      return '毎日'
    }
    if (typeTime === 'WEEKLY') {
      return `${'毎週 ' + '('}${renderAvailableDay(
        node.isAvailableOnMonday,
        node.isAvailableOnTuesday,
        node.isAvailableOnWednesday,
        node.isAvailableOnThursday,
        node.isAvailableOnFriday,
        node.isAvailableOnSaturday,
        node.isAvailableOnSunday,
        node.isAvailableOnHoliday
      )})`
    }
    if (typeTime === 'MONTHLY') {
      return renderAvailableDayInMoth(node.dateMatrix)
    }
  }
  return (
    <RecruitmentScheduleShiftListScene
      fortmatDate={fortmatDate}
      edges={edges}
      count={count}
      i18n={i18n}
      page={parseInt(page, 10)}
      rowsPerPage={parseInt(rowsPerPage, 10)}
      onPageChange={onPageChange(history, search)}
      fullname={fullname}
      name_contains={name_contains}
      isCreateScheduleAvailableShift={isCreateScheduleAvailableShift}
      onSortHandle={onSortHandle}
      orderBy={orderBy}
    />
  )
}

export default RecruitmentScheduleShiftList
